<template>
  <main class="container my-5">
    <ListarPlanoCliente :objPlanoCliente="objPlanoCliente" />
  </main>
</template>

<script>
// @ is an alias to /src
import { APIService } from "../APIService";
const apiService = new APIService();
import ListarPlanoCliente from "../components/planoCliente/ListarPlanoCliente";

export default {
  name: "PlanoCliente",
  components: {
    ListarPlanoCliente
  },
  data() {
    return {
      objPlanoCliente: null,
      idDetalhes: this.$route.params.idDetalhes
    };
  },
  created() {
   this.obterServicosPlanoCliente();
  },
  methods: {
    obterServicosPlanoCliente() {
      apiService
        .obterServicosPlanoCliente(0, this.$route.params.idAssinatura)
        .then(response => {
          this.objPlanoCliente = response;
        });
    }
  }
};
</script>
<style scoped lang="scss"></style>
